import { useNavigate } from "react-router-dom";
import logo from "../../Assets/logo.png";

interface MobileHeaderProps {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
}

export function MobileHeader({ title, showBack, onBack }: MobileHeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) onBack();
    else navigate(-1);
  };

  return (
    <header className="sticky top-0 z-40 flex h-[52px] shrink-0 items-center gap-2 bg-header-bar px-3 shadow-sm">
      {showBack ? (
        <button
          type="button"
          onClick={handleBack}
          className="flex h-9 w-9 items-center justify-center rounded-lg text-xl text-white/90 transition-colors hover:bg-white/15"
          aria-label="Go back"
        >
          ‹
        </button>
      ) : (
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/20 p-0.5">
          <img src={logo} alt="" className="h-full w-full rounded-md object-contain" />
        </div>
      )}
      <h1 className="min-w-0 flex-1 truncate text-base font-semibold text-white">
        {title}
      </h1>
    </header>
  );
}
